import Vue from "vue";
import Vuex from "vuex";
import { extractVuexModule, createProxy } from "vuex-class-component";
import AppStore from "./app";
import AuthStore from "./auth";
import GamesStore from "./games";
import ResultsStore from "./results";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    ...extractVuexModule(AppStore),
    ...extractVuexModule(AuthStore),
    ...extractVuexModule(GamesStore),
    ...extractVuexModule(ResultsStore)
  }
});

export default store;

export const vxm = {
  app: createProxy(store, AppStore),
  auth: createProxy(store, AuthStore),
  games: createProxy(store, GamesStore),
  results: createProxy(store, ResultsStore)
};
